"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFitSizeToElement = exports.getRectCenter = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getRectCenter = exports.getRectCenter = function getRectCenter(_ref) {
  var width = _ref.width,
    height = _ref.height,
    left = _ref.left,
    top = _ref.top;
  var x = left + width / 2;
  var y = top + height / 2;
  return {
    x: x,
    y: y
  };
};
function calculateViewOffset(visualization, element) {
  var canvas = visualization.renderer && visualization.renderer.domElement;
  var containerRect = canvas.getBoundingClientRect();
  var width = containerRect.width,
    height = containerRect.height;
  var _getRectCenter = getRectCenter(containerRect),
    cx = _getRectCenter.x,
    cy = _getRectCenter.y;
  var _getRectCenter2 = getRectCenter(element.getBoundingClientRect()),
    tx = _getRectCenter2.x,
    ty = _getRectCenter2.y;
  var offsetX = cx - tx;
  var offsetY = cy - ty;
  return {
    offsetX: offsetX,
    offsetY: offsetY,
    width: width,
    height: height,
    fullWidth: width,
    fullHeight: height
  };
}

/**
 * @param {ThreeBase} visualization
 * @param {Element} element
 */
var updateFitSizeToElement = exports.updateFitSizeToElement = function updateFitSizeToElement(visualization, element) {
  if (visualization && visualization.setFitSize) {
    if (!element) {
      visualization.setFitSize(null);
    } else {
      var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;
      if (width > 0 && height > 0) {
        visualization.setFitSize({
          width: width,
          height: height
        });
      }
    }
  }
  return {
    updateCameraPosition: function updateCameraPosition() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var updateFn = visualization.setCameraPositionToCurrentDesignArea;
      updateFn && updateFn.call(visualization, _objectSpread(_objectSpread({}, options), {}, {
        getViewOffset: function getViewOffset() {
          return calculateViewOffset(visualization, element);
        }
      }));
    }
  };
};